module.exports = __webpack_public_path__ + "img/gb5784-86-m10x20.prt.2259c6a1.jpg";